export default __webpack_public_path__ + "static/zaru_collages_v6-18-1d5c51902595d1cd41eea128a8527d50.png";